import React, { useContext } from 'react';

import { media } from 'context';
import { Icon, Layout, Link, Text } from 'ds';
import { PANTRY_PATH } from 'routes';

import { WidgetVariant } from './types';

interface Props {
  variant: WidgetVariant;
}

const ConsumablesServiceWidget: React.FC<Props> = ({ variant }) => {
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Link href={PANTRY_PATH} color="black" fullWidth fullHeight>
        <Layout
          direction="row"
          align="flex-end"
          justify="space-between"
          borderRadius={16}
          padding={12}
          color="white"
          gap={8}
          height="100%"
        >
          <Text size="body-xs" color="purple-gradient" semibold __style={{ verticalAlign: 'bottom' }}>
            Customize your pantry items
          </Text>
          <Icon name="rightChevron" color="purple-gradient" size={30} />
        </Layout>
      </Link>
    );
  }
  if (variant === 'half') {
    return (
      <Link href={PANTRY_PATH} color="black" fullWidth fullHeight>
        <Layout align="center" paddingX={16} gap={12} height="100%" color="white" borderRadius={16}>
          <Layout direction="column" gap={12}>
            <Text size="body-xs" color="purple-gradient" semibold>
              Customize your pantry items
            </Text>
            <Layout paddingX={12} paddingY={4} borderRadius={16} color="purple-gradient" width="fit-content">
              <Text size="body-xs" color="white" semibold>
                Shop pantry
              </Text>
            </Layout>
          </Layout>
          <Icon name="beverageSupplies" color="purple-gradient" size={32} />
        </Layout>
      </Link>
    );
  }
  return (
    <Link href={PANTRY_PATH} color="black" fullWidth fullHeight>
      <Layout
        borderRadius={16}
        paddingX={16}
        gap={16}
        direction="column"
        align="center"
        justify="center"
        height="100%"
        color="white"
      >
        <Layout direction="column" gap={4} align="center">
          <Icon name="beverageSupplies" color="purple-gradient" size={32} />
          <Text size="body-md" color="purple-gradient" align="center" semibold>
            Never run
            <br />
            on empty again.
          </Text>
        </Layout>
        <Layout borderRadius={16} color="purple-gradient" paddingX={12} paddingY={4} display="inline-flex">
          <Text size="body-xs" color="white" semibold>
            Shop pantry
          </Text>
        </Layout>
      </Layout>
    </Link>
  );
};

export default ConsumablesServiceWidget;
